var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 26,
    viewBox: "0 0 19 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9296 25.9323H16.8462V20.6792C16.8454 19.8625 16.5206 19.0795 15.9431 18.502C15.3657 17.9246 14.5827 17.5998 13.766 17.599H5.34311C4.52644 17.5998 3.74346 17.9246 3.16598 18.502C2.58851 19.0795 2.26373 19.8625 2.2629 20.6792V25.9323H0.179565V20.6792C0.181219 19.3102 0.725765 17.9978 1.69376 17.0298C2.66175 16.0618 3.97416 15.5173 5.34311 15.5156H13.766C15.135 15.5173 16.4474 16.0618 17.4154 17.0298C18.3834 17.9978 18.9279 19.3102 18.9296 20.6792V25.9323Z",
    fill: "#5B5B5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55457 13.4326C8.31843 13.4326 7.11006 13.0661 6.08225 12.3793C5.05445 11.6925 4.25337 10.7164 3.78032 9.57439C3.30727 8.43235 3.1835 7.17569 3.42466 5.9633C3.66582 4.75092 4.26107 3.63728 5.13515 2.7632C6.00923 1.88912 7.12287 1.29387 8.33525 1.05271C9.54763 0.811554 10.8043 0.935325 11.9463 1.40837C13.0884 1.88142 14.0645 2.6825 14.7513 3.71031C15.438 4.73811 15.8046 5.94649 15.8046 7.18262C15.8029 8.83971 15.1439 10.4285 13.9722 11.6002C12.8004 12.772 11.2117 13.431 9.55457 13.4326ZM9.55457 3.01595C8.73048 3.01595 7.9249 3.26032 7.23969 3.71816C6.55449 4.176 6.02043 4.82675 5.70507 5.58811C5.3897 6.34946 5.30719 7.18724 5.46796 7.9955C5.62873 8.80375 6.02557 9.54618 6.60829 10.1289C7.19101 10.7116 7.93344 11.1085 8.74169 11.2692C9.54995 11.43 10.3877 11.3475 11.1491 11.0321C11.9104 10.7168 12.5612 10.1827 13.019 9.49749C13.4769 8.81229 13.7212 8.00671 13.7212 7.18262C13.7212 6.07755 13.2822 5.01774 12.5008 4.23634C11.7194 3.45494 10.6596 3.01595 9.55457 3.01595Z",
    fill: "#5B5B5B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIc);
export default __webpack_public_path__ + "static/media/user_ic.fda2e63a4c73294929514436b2c9ad83.svg";
export { ForwardRef as ReactComponent };